module.exports = __webpack_public_path__ + "media/images/redrock/stone_front-30f20f38b2944ca55e54f119a2e1373a.jpg";